import { PanelbarStructure } from "../isPanelbarDetails.js";
import { Helper } from "../../util/helper.js";
import { StringKeyDictionary } from "../../../commonInterfaces.js";
import React from "react";
export default class ProjectDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};


    componentDidMount() {
        Helper.getTranslations(["Field.Einsatz.projnr", "Field.Projekt.projnr2", "Projekt.Adresse1", "Projekt.Adresse2", "Projekt.Adresse3", "Field.Projekt.status", "Projekt.Auftragsart", "Standard.Von", "Standard.Bis"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }

    render() {
        let data = $.extend({ Project: {}, Addons: {} }, this.props.data);

        const mainLabelExtension = Helper.hasValue(data.Project.Kennwort) ? (": " + data.Project.Kennwort) : "";


        return (
            <PanelbarStructure label={data.Project.ProjNr + mainLabelExtension} keyPropValue={data.Project.ProjNr} iconName={"folder-open"} url={"Project/Edit?id=" + encodeURIComponent(data.Project.ProjNr)}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span>{data.Project.ProjNr2}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Addons.Adrname + ", " + data.Project.AdressOrt}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Project.Status}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Addons.Auart}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Standard.Von"]}</span>
                            </td>
                            <td>
                                <span>{Helper.dates.toString(data.Project.StartSoll)}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Standard.Bis"]}</span>
                            </td>
                            <td>
                                <span>{Helper.dates.toString(data.Project.EndeSoll)}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}
